module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"history_chosen_tables":"List of chosen tables for history","history_start":"History start","history_stop":"History stop"},"fr":{"history_chosen_tables":"Liste des tables choisies pour l\u0027historique","history_start":"Début de l\u0027historique","history_stop":"Fin de l\u0027historique"}}')
  delete Component.options._Ctor
}
